import { Button } from "../../ui/Button";
import { ModeSelectionRailProps } from "./ModeSelectionRail.contract";

export function ModeSelectionRail({ currentMode, onModeChange }: ModeSelectionRailProps) {
  return (
    <div
      className="hidden lg:flex gap-1 bg-black/5 p-1 rounded-full ml-2"
      aria-label="Mode selection"
    >
      {(["user", "staff", "admin"] as const).map((mode) => (
        <Button
          key={mode}
          variant="ghost"
          size="sm"
          className={`rounded-full text-[10px] font-bold tracking-[0.14em] ${currentMode === mode ? "bg-white text-brand-ink shadow-sm" : "text-brand-muted hover:text-brand-ink"}`}
          aria-pressed={currentMode === mode}
          onClick={() => onModeChange?.(mode)}
        >
          {mode.toUpperCase()}
        </Button>
      ))}
    </div>
  );
}
